import {rootState} from '@mintdata-wsp/common/state/RootState';
import {FlowComponent, FlowDragContext} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {NameUtil} from '@mintdata-wsp/common/util/NameUtil';
import {WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {HighlightedText} from '@mintdata-wsp/wsp/ui/components/text/HighlightedText';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./CloudComponentPreview.less');
const cx = classnames.bind(styles);

export enum CloudComponentPreviewMode
{
    IconBlock,
    TextRow,
}

export interface CloudComponentPreviewProps
{
    isVisible:boolean;
    mode:CloudComponentPreviewMode;
    component:FlowComponent;
    className?:string;
    highlightNamePart?:string;
}

@observer
export class CloudComponentPreview extends React.Component<CloudComponentPreviewProps, any>
{
    private _elem:HTMLElement;

    @bind
    _onRef(elem:HTMLElement)
    {
        this._elem = elem;
    }

    @action.bound
    _onMouseDown(e:React.MouseEvent<any>)
    {
        const browserEvent = e.nativeEvent;
        const glass = rootState.ui.visualDesigner.flow.glass;
        const boundingClientRect = this._elem.getBoundingClientRect();

        const ctx = new FlowDragContext(this._elem, boundingClientRect, browserEvent, this.props.component);

        glass.dragContext = ctx;
    }

    _renderDisplayName()
    {
        const {component, highlightNamePart} = this.props;
        const cloudComponent = component.component;
        const displayName = NameUtil.getDisplayName(cloudComponent);

        return <HighlightedText text={displayName} partToHighlight={highlightNamePart} />;
    }

    _renderIconBlock()
    {
        const {className, component, isVisible} = this.props;
        const cloudComponent = component.component;
        const iconElement = controllers.ui.componentIcons.getForCloudComponent(cloudComponent, WSPIconSize.xlarge_64);

        return <Column className={cx('previewArea',
            {'visible': isVisible},
            {'notVisible': !isVisible},
            className
        )}
                       aRef={this._onRef} onMouseDown={this._onMouseDown}>

            <Row className={cx('icon')}>
                {iconElement}
            </Row>
            <Row className={cx('text')}>
                {this._renderDisplayName()}
            </Row>

        </Column>;
    }

    _renderTextRow()
    {
        const {component} = this.props;
        const cloudComponent = component.component;
        const displayName = NameUtil.getDisplayName(cloudComponent);

        return <Row>{displayName}</Row>;
    }

    render()
    {
        const {mode} = this.props;

        if( mode === CloudComponentPreviewMode.IconBlock )
            return this._renderIconBlock();
        else if( mode === CloudComponentPreviewMode.TextRow )
            return this._renderTextRow();
    }
}
